import { gql } from '@apollo/client';
import { PickupTaskResponse } from '../../types/PickupTaskType';

export const GET_PICKUP_TASKS = gql`
  query GetPickupTasks($filter: PickupTaskFilterInput, $pageRequest: PageRequestInput) {
    getPickupTasks(filter: $filter, pageRequest: $pageRequest) {
      data {
        id
        taskNumber
        taskDate
        status
        driverName
        vehicleLicensePlate
        vehicleModelId
        vehicleModelName
        vehicleTypeId
        vehicleTypeName
        startPointName
        endPointName
        appointmentCount
        completedAppointments
        actDepartureTime
        vehicleNumber
        loadRate
        routeName
        updatedAt
      }
      total
      page
      pageSize
    }
  }
`;

export type GetPickupTasksResponse = {
  getPickupTasks: PickupTaskResponse;
}; 